import React from 'react';
import styled from 'styled-components';
import { useSkipWidgetLink } from '../../../../shared/componentsV2/SkipWidgetLink';

export const StyledEmbed = styled.embed`
  width: 100%;
  max-width: 100%;
  height: 800px; /* Could be optimized. Seems tall enough for most PDFs, but leaves some space for single page sideways ones. */
  margin-top: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
`;

export function PdfPreview({ fileBlobUrl }: { fileBlobUrl: string }) {
  const ZOOM_TO_FIT_HORIZONTALLY = 'view=FitH';
  const previewModifiers = [ZOOM_TO_FIT_HORIZONTALLY].join('&');

  const { SkipLink, SkipLinkTarget } = useSkipWidgetLink();

  const srcUrl = `${fileBlobUrl}#${previewModifiers}`;

  return (
    <>
      <SkipLink linkText="Skip past form preview" />
      <StyledEmbed title="Form Preview" src={srcUrl} type="application/pdf" />
      <SkipLinkTarget />
    </>
  );
}
